import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { RouterModule } from '@angular/router';
import { DonationCardService } from '../../../services/donation-card.service';
import { SkeletonModule } from 'primeng/skeleton';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-donation-header',
  templateUrl: './donation-header.component.html',
  styleUrls: ['./donation-header.component.scss'],
  standalone: true,
  imports: [CommonModule, ButtonModule, DialogModule, RouterModule, SkeletonModule],
  providers: [MessageService]
})
export class DonationHeaderComponent implements OnInit {
  @Input() donationId!: number;
  @Input() activeTab!: string;
  @Input() isReadOnlyMode: boolean = false;
  @Output() donationAmountChange = new EventEmitter<number>();
  isHeaderDataModalVisible: boolean = false;
  headerData: any = null;
  @Output() editDonor = new EventEmitter<void>();
  @Output() donorIdClick = new EventEmitter<number>();
  @Output() deleteDonation = new EventEmitter<void>();
  @Output() editDonation = new EventEmitter<string>(); 

  constructor(private donationCardService: DonationCardService, private messageService: MessageService) {}

  ngOnInit(): void {
    this.loadHeaderData();
  }

  loadHeaderData(): void {
    this.donationCardService.getHeaderData(this.donationId).subscribe({
      next: (data) => {
        this.headerData = data;
        this.donationAmountChange.emit(this.headerData.donationAmount);
      },
      error: (err) => {
        console.error('Unable to retrieve header data. Please try again later.', err);
      }
    });
  }

  openHeaderDataModal(): void {
    this.isHeaderDataModalVisible = true;
  }

  onEditDonation(): void {
    this.editDonation.emit('parent-child'); // Emit the active tab name
  }

  onDeleteDonation(): void {
    this.deleteDonation.emit();
  }

  onSave() {
    if (this.isReadOnlyMode) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Read Only',
        detail: 'This header is in read-only mode. Saving is disabled.'
      });
      return;
    }
    // ...existing save logic...
  }
}
